import { Scene, GameObjects } from 'phaser';

export class GamaruSplash extends Scene {
  private video: GameObjects.Video | null = null;
  private hasContinued: boolean = false;

  constructor() {
    super('GamaruSplash');
  }

  create(): void {
    const { width, height } = this.scale;

    // Black background
    this.cameras.main.setBackgroundColor('#000000');

    // Gamaru video centered
    this.video = this.add.video(width / 2, height / 2, 'gamaru_video');
    this.video.setAlpha(0);

    // Mute video for autoplay (browser policy)
    this.video.setMute(true);

    // Play video immediately (muted allows autoplay)
    this.video.play();

    // Scale video once it has loaded and has dimensions
    this.video.on('play', () => {
      if (this.video && this.video.width > 0 && this.video.height > 0) {
        const scaleRatio = Math.min(width / this.video.width, height / this.video.height) * 0.9;
        this.video.setScale(scaleRatio);
      }
    });

    // Fade in video
    this.tweens.add({
      targets: this.video,
      alpha: 1,
      duration: 500,
      ease: 'Power2',
    });

    // When video ends, fade out and continue
    this.video.on('complete', () => {
      this.fadeOutAndContinue();
    });

    // Fallback: if video doesn't trigger complete, continue after timeout
    this.time.delayedCall(10000, () => {
      if (this.scene.isActive('GamaruSplash')) {
        this.fadeOutAndContinue();
      }
    });

    // Allow skip with click/key
    this.input.once('pointerdown', () => this.fadeOutAndContinue());
    this.input.keyboard?.once('keydown', () => this.fadeOutAndContinue());
  }

  private fadeOutAndContinue(): void {
    if (this.hasContinued) return;
    this.hasContinued = true;

    if (this.video) {
      this.video.stop();
    }

    // Fade out video
    this.tweens.add({
      targets: this.video,
      alpha: 0,
      duration: 500,
      ease: 'Power2',
      onComplete: () => {
        // Go to Preloader
        this.scene.start('Preloader');
      },
    });
  }
}
